import axiosInstance from '../axios.instance';

export const getNotificationsApi = (token, params) => axiosInstance.get('notification/all', {
  params,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getUnreadNotificationsApi = (token, params) => axiosInstance.get('notification/get-unread', {
  params,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const readNotificationApi = (token, id) => axiosInstance.post(`notification/make-read/${id}`, null, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const readAllNotificationsApi = (token) => axiosInstance.post('notification/make-all-read', null, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
